import { routes } from "src/navigation/routes";
import { works } from './works';

export const StudentHomeworks = () => (
  <>
    <div className="sectionHb-top">
      <h2 className="sectionHb-title">
        Homeworks
      </h2>
    </div>

    <div className="sectionHb-block purchaseHb">
      <div className="sectionHb-block__wrap">
        <ul>
          {Object.keys(works).map((key) => (
            <li key={key}>
              <h4><a href={routes.homeworks.show(key)}>{key}. {works[key].title}</a></h4>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </>
)
